import { useImageCarousel } from '@hooks/useImageCarousel'
import PaginationDots from '@components/PaginationDots'
import styles from '@styles/ImageCarousel.module.css'
import { Link } from 'react-router-dom'
import { useEffect } from 'react'

const ImageCarousel = () => {
  const { currentIndex, direction, isReserved, currentLens, handlePrev, handleNext, lensData } = useImageCarousel()

  useEffect(() => {
    const link = document.createElement('link')
    link.rel = 'preload'
    link.as = 'image'
    link.href = lensData[0].image
    document.head.appendChild(link)
    return () => document.head.removeChild(link)
  }, [lensData])

  return (
    <div className={styles.carousel}>
      <div
        className={styles.background}
        style={{
          background: `
          linear-gradient(to right,
            ${isReserved ? '#ffffff' : currentLens.backgroundColor} 50%,
            ${
              isReserved ? currentLens.backgroundColor : '#ffffff'
            } 50%)`,
        }}
      />

      <div className={styles.centeredTextContainer}>
        <h2
          className={styles.centeredText}
          style={{
            color: `${currentLens.backgroundColor}`,
            WebkitTextStroke: `2px ${currentLens.textColor}`,
            opacity: 0.5,
          }}
        >
          NATALÚ
        </h2>
      </div>

      <div className={styles.carouselContainer}>
        <div className={styles.imageContainer}>
          {lensData.map((lens, index) => (
            <div
              key={lens.name}
              className={styles.imageWrapper}
              style={{
                transform: `
                translateX(${100 * (index - currentIndex)}%)
                rotateY(${direction * 45}deg)
                scale(${index === currentIndex ? 1 : 0.8})
                `,
                opacity: index === currentIndex ? 1 : 0,
                zIndex: index === currentIndex ? 1 : 0,
              }}
            >
              <div className='image-container'>
                <img
                  src={lens.image}
                  alt={`${lens.name} Glasses`}
                  className='image'
                  loading={index === 0 ? 'eager' : 'lazy'}
                  width='100%'
                  height='auto'
                />
              </div>
            </div>
          ))}
        </div>

        <div className={styles.textContainer} style={{ transform: `translateY(${direction * 20}px)` }} >
          <p className={styles.subtitle}>ACCESORIOS</p>
          <h1 className={styles.title}>{currentLens.name}</h1>
          <button className={styles.button}>
            <Link to='/ofertas' className={styles.link}>
            VER OFERTAS
            </Link>
            </button>
        </div>
      </div>

      <button onClick={handlePrev} className={`${styles.prevButton}`} aria-label='Previous image' >
        ←
      </button>
      <button onClick={handleNext} className={`${styles.nextButton}`} aria-label='Next image' >
        →
      </button>

      <PaginationDots currentPage={currentIndex} totalPages={lensData.length} />
    </div>
  )
}

export default ImageCarousel